<p class="user-avatar"><img src="assets/app-branding/img/avatars/cartoon/4.png"
       [alt]="i18n.str('challengeu.challengeu.avatar_picture', 'Your avatar picture')()" /></p>
<h2>Welcome, Evelina!</h2>


<div class="jeopardy-mode-grid">
  <div>
    <p>
      <a href="#">
        <img src="assets/app-branding/img/icons/Icons-sp-small.png"
             [alt]="i18n.str('challengeu.main_singleplayer', 'Click to select single player')()" />
      </a>
    </p>
    <h2>SINGLE PLAYER</h2>
  </div>
  <div>
    <p>
      <a href="#">
        <img src="assets/app-branding/img/icons/Icons-mp-small.png"
             [alt]="i18n.str('challengeu.main_multi_player', 'Click to select multiplayer')()" />
      </a>
    </p>
    <h2>MULTIPLAYER</h2>
  </div>
  <div>
    <p>
      <a href="#">
        <img src="assets/app-branding/img/icons/Icons-rules-small.png"
             [alt]="i18n.str('challengeu.main_rules', 'Rules of the game')()" />
      </a>
    </p>
    <h2>RULES OF THE GAME</h2>
  </div>
  <p>
    <a href="#">
      <img src="assets/app-branding/img/icons/Icons-music-small.png"
           [alt]="i18n.str('challengeu.main_music_off', 'Music off')()" />
    </a>
  </p>
  <p>
    <a href="#">
      <img src="assets/app-branding/img/icons/Icons-sounds-small.png"
           [alt]="i18n.str('challengeu.main_sounds_off', 'Music on')()" />
    </a>
  </p>
  <p>
    <a href="#">
      <img src="assets/app-branding/img/icons/Icons-settings-small.png"
           [alt]="i18n.str('challengeu.main_settings', 'Settings')()" />
    </a>
  </p>
</div>
